[
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Data Channels",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Consents",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Resources",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Customers",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Auto",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Patrimonial",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Person",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Housing",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Financial Risk",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Responsibility",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Rural",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Transport",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Acceptance And Branches Abroad",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Financial Assistance",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Capitalization Title",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Pension Plan",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Life Pension",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Claim Notification",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Quote Auto",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Quote Housing",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Quote Rural",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Quote Transport",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Quote Person",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Quote Capitalization Title",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Contract Life Pension",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Withdrawal",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Dynamic Fields",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Webhook",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Data Channels (v3)",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Intermediary",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Intermediary (v3)",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Referenced Network",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Referenced Network (v3)",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Assistance General Assets",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Assistance General Assets (v3)",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Auto Extended Warranty",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Auto Extended Warranty (v3)",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Auto Insurance",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Auto Insurance (v3)",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Business",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Business (v3)",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Capitalization Title",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Capitalization Title (v3)",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Condominium",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Condominium (v3)",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Cyber Risk",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Cyber Risk (v3)",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Directors & Officers Liability",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Directors & Officers Liability (v3)",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Domestic Credit",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Domestic Credit (v3)",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Engineering",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Engineering (v3)",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Environmental Liability",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Environmental Liability (v3)",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Equipment Breakdown",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Equipment Breakdown (v3)",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Errors & Omissions Liability",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Errors & Omissions Liability (v3)",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Export Credit",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Export Credit (v3)",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Extended Warranty",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Extended Warranty (v3)",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Financial Risk",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Financial Risk (v3)",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — General Liability",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — General Liability (v3)",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Home Insurance",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Home Insurance (v3)",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Housing",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Housing (v3)",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Life Pension",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Life Pension (v3)",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Lost Profit",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Lost Profit (v3)",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Pension Plan",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Pension Plan (v3)",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Person",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Person (v3)",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Private Guarantee",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Private Guarantee (v3)",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Public Guarantee",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Public Guarantee (v3)",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Rent Guarantee",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Rent Guarantee (v3)",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Rural",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Rural (v3)",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Stop Loss",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Stop Loss (v3)",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Transport",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Open Data — Transport (v3)",
    "regulatoryVersion": "v3.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Endorsement",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Notifications",
    "regulatoryVersion": "v1.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Quote Patrimonial",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Quote Responsibility",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Quote Financial Risk",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Quote Acceptance And Branches Abroad",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Comuns (Status & Outages)",
    "regulatoryVersion": "v1.3.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Comuns (Status & Outages) (v2)",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Admin (Metrics)",
    "regulatoryVersion": "v1.3.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  },
  {
    "ecosystem": "opin",
    "lane": "official-conformance",
    "family": "Admin (Metrics) (v2)",
    "regulatoryVersion": "v2.0.0",
    "targetProfile": "current",
    "toolName": "official-opin-conformance-suite",
    "runAt": null,
    "result": "missing",
    "official": true,
    "evidenceFile": null,
    "notes": "No official OPIN conformance artifact has been attached for this family/version."
  }
]
